import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Comforter_Brush\",\"arguments\":[{\"variable\":\"--font-comforter-brush\",\"subsets\":[\"latin\"],\"weight\":\"400\",\"display\":\"swap\"}],\"variableName\":\"comforterBrush\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Noto_Serif\",\"arguments\":[{\"variable\":\"--font-noto-serif\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSerif\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"variable\":\"--font-noto-sans\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/workspace/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppPostMessage"] */ "/workspace/src/components/app-postmessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/appBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/article-audio-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/infront/ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/javascript-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/kilkaya-spa-ready.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/navigation/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/podcast-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/settings.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/sidebar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/skip-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/sub-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/todays-important/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleAudioContextProvider"] */ "/workspace/src/context/article-audio-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfrontContextProvider"] */ "/workspace/src/context/infront-context/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuContextProvider"] */ "/workspace/src/context/menu-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerContextProvider"] */ "/workspace/src/context/player-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarContextProvider"] */ "/workspace/src/context/sidebar-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeContextProvider"] */ "/workspace/src/context/theme-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnitProvider"] */ "/workspace/src/context/unit-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextProvider"] */ "/workspace/src/context/user-context.tsx");
